// The 10 chicken-fighter classes (REBRAND_BIBLE §2). Internal ids are the
// port ids — never the source job ids. `body`/`accent` drive the programmatic
// canvas art so every fighter reads distinctly without external images.

export interface Fighter {
  id: string;
  name: string;
  identity: string;
  body: string; // primary plumage colour
  accent: string; // comb / tail / spur accent
  crest: "blade" | "cannon" | "quill" | "gaff" | "halo" | "ember" | "frost" | "gale" | "bolt" | "shadow";
  /**
   * Index into the five VERIFIED per-class stat blocks from combat.json
   * (frame_498 order). The four weapon archetypes + holy map 1:1; the five
   * element roosters (no stat blocks in the source, VERIFIED absence) borrow
   * the closest archetype block so balance stays 1:1 with recovered data.
   * 0 = blade/melee, 1 = pike/reach, 2 = firearm, 3 = archer, 4 = radiant.
   */
  statIdx: 0 | 1 | 2 | 3 | 4;
}

export const ROSTER: Fighter[] = [
  { id: "spurblade", name: "Spurblade", identity: "Duelist rooster who fights with razor leg-spurs.", body: "#d94f4f", accent: "#ffd166", crest: "blade", statIdx: 0 },
  { id: "cannoneer", name: "Corn Cannoneer", identity: "Struts a kernel-cannon; fires hardened corn shot.", body: "#e0922f", accent: "#ffe08a", crest: "cannon", statIdx: 2 },
  { id: "quill", name: "Quill Archer", identity: "Plucks and looses her own sharpened quills.", body: "#5ec26a", accent: "#d7ffd9", crest: "quill", statIdx: 3 },
  { id: "gaff", name: "Gaff Lancer", identity: "Long-reach pike-fighter with a steel gaff.", body: "#8a8f98", accent: "#dfe6ef", crest: "gaff", statIdx: 1 },
  { id: "dawncrower", name: "Dawncrower", identity: "The sunrise crow made a weapon; radiant light.", body: "#f4d35e", accent: "#fff6d6", crest: "halo", statIdx: 4 },
  { id: "emberplume", name: "Emberplume", identity: "Feathers smolder; hurls cinders and flame.", body: "#f2683c", accent: "#ffd08a", crest: "ember", statIdx: 2 },
  { id: "frostfeather", name: "Frostfeather", identity: "A blue-white hen wreathed in freezing down.", body: "#8fd6ff", accent: "#eaffff", crest: "frost", statIdx: 1 },
  { id: "galecrest", name: "Galecrest", identity: "Bantam speedster; whips up cutting windstorms.", body: "#7de3c4", accent: "#e6fff7", crest: "gale", statIdx: 3 },
  { id: "thundercluck", name: "Thundercluck", identity: "Storm-charged rooster; every crow a lightning bolt.", body: "#b48bff", accent: "#fff07a", crest: "bolt", statIdx: 0 },
  { id: "shadowmoult", name: "Shadowmoult", identity: "Moults into shadow; strikes from the dark of the coop.", body: "#5b5470", accent: "#c4b5fd", crest: "shadow", statIdx: 4 },
];

export function fighterById(id: string): Fighter {
  return ROSTER.find((f) => f.id === id) ?? ROSTER[0];
}
